import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
function getGlobalThemeValue(field, propValue) {
  return function (theme) {
    if (propValue === undefined) {
      return undefined;
    }
    var getFieldValue = function getFieldValue(value) {
      var _theme$globals$field;
      return ((_theme$globals$field = theme.globals[field]) === null || _theme$globals$field === void 0 ? void 0 : _theme$globals$field[value]) || value;
    };
    if (Array.isArray(propValue)) {
      // Filter out undefined values from the array to keep the return type clean
      return propValue.filter(function (v) {
        return v !== undefined;
      }).map(getFieldValue);
    }
    return getFieldValue(propValue);
  };
}
export default getGlobalThemeValue;